import React from 'react';
import { Link } from 'react-router-dom'; // Optional, if using react-router for navigation

const NotFound = () => {
  return (
    <div className="not-found-container">
      <h1 className="not-found-title">404</h1>
      <p className="not-found-text">Oops! The page you're looking for doesn't exist.</p>
      <Link to="/assessment" className="not-found-link">Go back to Homepage</Link>
    </div>
  );
};

export default NotFound;
